// extracted by mini-css-extract-plugin
module.exports = {"component":"BackToTop_component__9mg5t","background":"BackToTop_background__sZmlw","scanNote":"BackToTop_scanNote__YQpYK","qrcode":"BackToTop_qrcode___Y8Iq"};